import {
    AJAX_TYPE
} from '../config';

const prefix = 'userManager';

export default {
    // 新增/修改用户
    ['saveAuthUser']: {
        url: '/api/manage/saveAuthUser',
        type: AJAX_TYPE.POST
    },
    //修改用户
    ['editAuthUser']: {
        url: '/api/manage/editAuthUser',
        type: AJAX_TYPE.POST
    },
    //获取用户详情
    ['authUserDetail']: {
        url: `/api/manage/authUserDetail?userId=:userId`,
        type: AJAX_TYPE.GET
    },
    //用户列表
    [`${prefix}userManageList`]: {
        url: '/api/manage/userManageList',
        type: AJAX_TYPE.POST
    },
    //修改用户状态
    [`${prefix}SetStatus`]: {
        url: '/api/manage/updateUserStatus',
        type: AJAX_TYPE.POST
    },
    //设为管理员
    [`${prefix}SetAdministrator`]: {
        url: '/api/manage/admin/setAdministrator',
        type: AJAX_TYPE.POST
    },
    //取消管理员权限
    [`${prefix}CancelAdministrator`]: {
        url: '/api/manage/admin/cancelAdministrator',
        type: AJAX_TYPE.POST
    },
    //删除用户
    [`${prefix}DelAuthUser`]: {
        url: '/api/manage/admin/delAuthUser',
        type: AJAX_TYPE.POST
    },
        

    // 角色删除
    [`${prefix}Detail`]: {
        url: '/web/crm/user/manageDetail/:userCode',
        type: AJAX_TYPE.GET
    } , [`${prefix}MyLabel`]: {
        url: '/web/crm/label/getListByUserId/:userCode',
        type: AJAX_TYPE.GET
    },
    [`${prefix}Export`]: {
        url: '/web/crm/user/exportRemoteUserList',
        type: AJAX_TYPE.POST
    },
    [`${prefix}ExportAuth`]: {
        url: '/web/crm/user/exportisUser',
        type: AJAX_TYPE.GET
    }
 
}